import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import Constants from "../../../../common/CustomerConstants";
import { SearchField } from "../../../../Components/formElements/SearchField";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { currencyFormat, formatDateTime } from "../../../../common/Validations";
import {
  getPurchaseList,
  purchaseNr,
} from "../../../../redux/feature/customer_app/customerSlice";
import CustomerConstants from "../../../../common/CustomerConstants";
import CommonFilterCustomerV2 from "../Common/CommonFilterCustomerV2";
// import UploadPurchaseOrder from "./UploadPurchaseModal";
import UploadModal from "../Common/UploadModal";
import UploadDataViewModal from "../Common/UploadDataViewModal";
import DownloadExcelTemplate from "../Common/DownloadExcelTemplate";
import toast from "react-hot-toast";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import ItemService from "../../../../services/customer_appCommonService";

const PurchaseList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Customer");
  localStorage.setItem("submenu", "Purchase List");

  let purchaseData = useSelector((state) => state?.customer?.purchase); // User Details from Store
  let purchaseDataTable = useSelector(
    (state) => state?.customer?.purchase?.pagination
  ); // User Details from Store
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [disable, setDisabled] = useState(false);
  const [getCompanyCode, setCompanyCode] = useState([]);

  const [parsedData, setParsedData] = useState([]);
  const [showDataModal, setShowDataModal] = useState(false);

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  let userData = useSelector((state) => state?.user?.data);
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  // const handleUploadComplete = (data) => {
  //   setParsedData(data);        // Store Excel data
  //   setShowDataModal(true);     // Show the preview modal
  // }

  // const InvoiceColumns = [
  //   {
  //     name: "Invoice No",
  //     selector: (row) => row.invoiceNr,
  //     sortable: true,
  //     width: "140px",
  //   },
  //   {
  //     name: "Generated Date",
  //     selector: (row) => row.generatedDate,
  //     sortable: true,
  //     width: "150px",
  //   },
  //   {
  //     name: "Material Desc",
  //     selector: (row) => row.materialDescription,
  //     sortable: true,
  //     // wrap: true,
  //     width: "200px",
  //   },
  //   {
  //     name: "Material Code",
  //     selector: (row) => row.materialCode,
  //     sortable: true,
  //     width: "150px",
  //   },
  //   {
  //     name: "PO Quantity",
  //     selector: (row) => row.poOrderQuantity,
  //     sortable: true,
  //     // right: true,
  //     width: "130px",
  //   },
  //   {
  //     name: "UOM",
  //     selector: (row) => row.uOM,
  //     sortable: true,
  //     width: "100px",
  //   },
  //   {
  //     name: "TCS Value",
  //     selector: (row) => row.tcsValue,
  //     sortable: true,
  //     // right: true,
  //     width: "130px",
  //   },
  //   {
  //     name: "Truck No",
  //     selector: (row) => row.loadingTruckNo,
  //     sortable: true,
  //     width: "130px",
  //   },
  //   {
  //     name: "CGST",
  //     selector: (row) => row.poTotalCgst,
  //     sortable: true,
  //     // right: true,
  //     width: "100px",
  //   },
  //   {
  //     name: "SGST",
  //     selector: (row) => row.poTotalSgst,
  //     sortable: true,
  //     // right: true,
  //     width: "100px",
  //   },
  //   {
  //     name: "IGST",
  //     selector: (row) => row.poTotalIgst,
  //     sortable: true,
  //     // right: true,
  //     width: "100px",
  //   },
  //   {
  //     name: "Net Value",
  //     selector: (row) => row.poTotalAmount,
  //     sortable: true,
  //     // right: true,
  //     width: "130px",
  //   },
  //   {
  //     name: "Tax Amt",
  //     selector: (row) => row.gstValue,
  //     sortable: true,
  //     // right: true,
  //     width: "120px",
  //   },
  //   {
  //     name: "Gross Value",
  //     selector: (row) => row.poTotalNetValue,
  //     sortable: true,
  //     // right: true,
  //     width: "140px",
  //   },
  // ];

  const loadMasterData = async () => {
    let obj1 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading Company Code");
      }
    });
  };

  useEffect(() => {
    loadMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  //{*/ For Bulk Upload Api /*}
  //-------------------------------------------------------------

  const handleUploadComplete = async ({ jsonData }) => {
    try {
      let companyMaster = getCompanyCode;
      if (!companyMaster || companyMaster.length === 0) {
        const resp = await ItemService.getMasterData({
          codeType: "companyCode",
          timeZone: "Asia/Calcutta",
        });
        if (resp?.status === 200 && Array.isArray(resp.data)) {
          companyMaster = resp.data;
          setCompanyCode(resp.data);
        } else {
          toast.error("Failed to load company master");
          return;
        }
      }

      const rows = (jsonData || []).map((r, idx) => ({
        __rowIndex: idx + 1,
        pONumber: (r.pONumber || "").toString().trim(),
        invoiceNr: (r.invoiceNr || "").toString().trim(),
        generatedDate: (r.generatedDate || "").toString().trim(),
        companyCode: (r.companyCode || "").toString().trim(),
        customerCode: (r.customerCode || "").toString().trim(),
        purchaseRemarks: (r.purchaseRemarks || "").toString().trim(),

        itemNo: Number(r.itemNo) || 0,
        materialCode: (r.materialCode || "").toString().trim(),
        qty: Number(r.qty) || 0,
        grossValue: Number(r.grossValue) || 0,

        dispatchDate: r.dispatchDate
          ? r.dispatchDate.toString().trim()
          : (r.generatedDate || "").toString().trim(),
        igstRate:
          r.igstRate !== "" && r.igstRate !== null && r.igstRate !== undefined
            ? Number(r.igstRate)
            : 0,
        local_id: idx + 1,
      }));

      const requiredCols = [
        "pONumber",
        "invoiceNr",
        "generatedDate",
        "companyCode",
        "customerCode",
        "itemNo",
        "materialCode",
        "qty",
        "grossValue",
      ];
      const errorsByRow = {};

      rows.forEach((row) => {
        const errs = [];
        requiredCols.forEach((col) => {
          const val = row[col];
          if (
            val === "" ||
            val === undefined ||
            val === null ||
            (typeof val === "number" && isNaN(val))
          ) {
            errs.push(`${col} is required`);
          }
        });

        if (row.companyCode) {
          const found = (companyMaster || []).find(
            (c) =>
              String(c.code) === String(row.companyCode) ||
              String(c.id) === String(row.companyCode)
          );
          if (!found)
            errs.push(`companyCode '${row.companyCode}' not found in master`);
        }

        if (errs.length) errorsByRow[row.__rowIndex] = errs;
      });

      if (Object.keys(errorsByRow).length > 0) {
        const mappedWithErrors = rows.map((r) => ({
          ...r,
          __errors: errorsByRow[r.__rowIndex],
        }));
        setParsedData(mappedWithErrors);
        setShowDataModal(true);
        toast.error("Some rows invalid. See preview.");
        console.error("Upload validation errors:", errorsByRow);
        return;
      }

      let materials = [];
      try {
        const matResp = await ItemService.getMaterials({
          timeZone: "Asia/Calcutta",
        });
        if (matResp?.status === 200 && Array.isArray(matResp.data))
          materials = matResp.data;
      } catch (err) {
        console.warn("getMaterials failed:", err);
      }
      const materialMap = {};
      materials.forEach((m) => {
        if (m.materialCode) materialMap[m.materialCode] = m;
        if (m._id) materialMap[m._id] = m;
      });

      const preview = rows.map((r) => {
        const mat = materialMap[r.materialCode] || {};
        const comp =
          (companyMaster || []).find(
            (c) =>
              String(c.code) === String(r.companyCode) ||
              String(c.id) === String(r.companyCode)
          ) || {};
        return {
          ...r,
          materialLongText:
            mat.materialLongText || mat.materialDescription || "",
          uOM: mat.uOM || "BAGS",
          cgstFromMaster: Number(mat.cgst || 0),
          sgstFromMaster: Number(mat.sgst || 0),
          hsn_sac: mat.hsn_sac || "",
          materialGroup: mat.materialGroup || "",
          companyCodeDesc: comp.description || comp.name || r.companyCode,
        };
      });

      setParsedData(preview);
      setShowDataModal(true);
    } catch (err) {
      console.error("handleUploadComplete error:", err);
      toast.error("Failed to parse uploaded file.");
    }
  };

  const handleSaveUploadedData = async (parsedData) => {
    if (!Array.isArray(parsedData) || parsedData.length === 0) {
      toast.error("No data to save.");
      return;
    }
    setDisabled(true);

    try {
      let companyMaster = getCompanyCode;
      if (!companyMaster || companyMaster.length === 0) {
        const resp = await ItemService.getMasterData({
          codeType: "companyCode",
          timeZone: "Asia/Calcutta",
        });
        if (resp?.status === 200 && Array.isArray(resp.data)) {
          companyMaster = resp.data;
          setCompanyCode(resp.data);
        }
      }

      let materials = [];
      try {
        const matResp = await ItemService.getMaterials({
          timeZone: "Asia/Calcutta",
        });
        if (matResp?.status === 200) materials = matResp.data;
      } catch (err) {
        console.warn("getMaterials failed:", err);
      }
      const materialMap = {};
      materials.forEach((m) => {
        if (m.materialCode) materialMap[m.materialCode] = m;
        if (m._id) materialMap[m._id] = m;
      });

      const groups = {};
      parsedData.forEach((row) => {
        if (row.__errors) return;
        const key = `${row.pONumber}__${row.invoiceNr}__${row.companyCode}__${row.customerCode}`;
        if (!groups[key]) groups[key] = [];
        groups[key].push(row);
      });

      const groupEntries = Object.entries(groups);
      if (groupEntries.length === 0) {
        toast.error("No valid PO groups to save.");
        setDisabled(false);
        return;
      }

      // 4) Process each PO group
      const results = await Promise.allSettled(
        groupEntries.map(async ([groupKey, rows]) => {
          // sort by itemNo
          rows.sort((a, b) => Number(a.itemNo) - Number(b.itemNo));
          const header = rows[0];

          // company master item
          const masterCompany = (companyMaster || []).find(
            (c) =>
              String(c.code) === String(header.companyCode) ||
              String(c.id) === String(header.companyCode)
          );

          let companyDetails = null;
          try {
            const compResp = await ItemServiceV2.getCompanyMaster({
              code: header.companyCode,
            });
            if (
              compResp?.status === 200 &&
              Array.isArray(compResp.data) &&
              compResp.data.length > 0
            )
              companyDetails = compResp.data[0];
          } catch (err) {
            console.warn(
              "getCompanyMaster failed for",
              header.companyCode,
              err
            );
          }

          // fetch customer detail for name/address
          let customerDetails = null;
          try {
            const custResp = await ItemService.getCustomerDetail({
              documentNumber: header.customerCode,
            });
            if (
              custResp?.status === 200 &&
              Array.isArray(custResp.data) &&
              custResp.data.length > 0
            )
              customerDetails = custResp.data[0];
          } catch (err) {
            console.warn(
              "getCustomerDetail failed for",
              header.customerCode,
              err
            );
          }

          const items = rows.map((row, idx) => {
            const qty = Number(row.qty) || 0;
            const grossValue = Number(row.grossValue) || 0;
            const igstRate = Number(row.igstRate) || 0;

            const mat = materialMap[row.materialCode] || {};
            const cgstPercent =
              igstRate > 0 ? 0 : Number(mat.cgst || row.cgstFromMaster || 0);
            const sgstPercent =
              igstRate > 0 ? 0 : Number(mat.sgst || row.sgstFromMaster || 0);
            const igstPercent = igstRate > 0 ? igstRate : 0;

            const totalTaxPercent = cgstPercent + sgstPercent + igstPercent;
            const netValue = totalTaxPercent
              ? Number((grossValue / (1 + totalTaxPercent / 100)).toFixed(2))
              : Number(grossValue.toFixed(2));

            const cgstValue = Number(
              ((cgstPercent * netValue) / 100).toFixed(2)
            );
            const sgstValue = Number(
              ((sgstPercent * netValue) / 100).toFixed(2)
            );
            const igstAmount = Number(
              ((igstPercent * netValue) / 100).toFixed(2)
            );
            const gstValue = Number(
              (cgstValue + sgstValue + igstAmount).toFixed(2)
            );

            const poBasicAmount = Number(netValue.toFixed(2));
            const basicPrice = qty
              ? Number((poBasicAmount / qty).toFixed(2))
              : 0;
            const rounded = Math.round(grossValue);
            const difference = Number((rounded - grossValue).toFixed(2));

            // resolve customer display name
            const customerDisplayName =
              customerDetails?.customerName ||
              customerDetails?.organisationName ||
              customerDetails?.name ||
              header.customerCode;

            return {
              slNo: (idx + 1).toString(),
              local_id: idx + 1,

              // material / item fields
              materialCode: row.materialCode,
              materialLongText:
                mat.materialLongText || row.materialLongText || "",
              materialDescription:
                mat.materialLongText || row.materialLongText || "",
              uOM: mat.uOM || row.uOM || "BAGS",

              poOrderQuantity: qty,
              grossValue: Number(grossValue.toFixed(2)),
              netValue,
              cgst: cgstPercent,
              sgst: sgstPercent,
              igstValue: igstPercent,

              cgstValue,
              sgstValue,
              igstAmount,
              gstValue,

              poBasicAmount,
              basicPrice,

              rounded,
              difference,

              hsn_sac: mat.hsn_sac || row.hsn_sac || "",
              materialGroup: mat.materialGroup || row.materialGroup || "",
              dispatchDate: row.dispatchDate || header.generatedDate,
              orderStatus: "Pending",

              // header fields
              invoiceNr: header.invoiceNr,
              generatedDate: header.generatedDate,
              companyCode: header.companyCode,
              companyCodeDesc:
                masterCompany?.description ||
                companyDetails?.description ||
                header.companyCode,
              customerCode: header.customerCode,
              customerName: customerDisplayName,
              purchaseRemarks: header.purchaseRemarks || "",

              creditAmount: netValue,

              createdBy: userData?.userId || "A000",
              createdDate: new Date().toISOString(),
            };
          });

          // compute totals
          const poTotals = items.reduce(
            (acc, it) => {
              acc.poTotalBags += Number(it.poOrderQuantity) || 0;
              acc.poTotalAmount += Number(it.poBasicAmount) || 0;
              acc.poTotalCgst += Number(it.cgstValue) || 0;
              acc.poTotalSgst += Number(it.sgstValue) || 0;
              acc.poTotalIgst += Number(it.igstAmount) || 0;
              acc.poTotalNetValue += Number(it.grossValue) || 0;
              return acc;
            },
            {
              poTotalBags: 0,
              poTotalAmount: 0,
              poTotalCgst: 0,
              poTotalSgst: 0,
              poTotalIgst: 0,
              poTotalNetValue: 0,
              poCgstValue_14: 0,
              poCgstValue_9: 0,
              poSgstValue_9: 0,
              poSgstValue_14: 0,
            }
          );

          const payload = {
            data: {
              companyCode: header.companyCode,
              companyCode2: header.companyCode,
              companyCodeDesc:
                masterCompany?.description ||
                companyDetails?.description ||
                header.companyCode,

              customerCode:
                header.customerCode || customerDetails?.customerCode || "",
              customerName:
                customerDetails?.customerName ||
                customerDetails?.organisationName ||
                header.customerCode,

              invoiceNr: header.invoiceNr,
              generatedDate: header.generatedDate,

              // customer address block
              address: customerDetails?.address || "",
              address2: customerDetails?.address2 || "",
              address3: customerDetails?.address3 || "",
              state: customerDetails?.state || "",
              cityPostalCode: customerDetails?.cityPostalCode || "",
              certifications: customerDetails?.certifications || [],

              // company address block
              companyAddress: [
                companyDetails?.address,
                companyDetails?.address2,
                companyDetails?.address3,
                companyDetails?.city,
                companyDetails?.state,
              ]
                .filter(Boolean)
                .join(" "),
              companyPostalCode: companyDetails?.cityPostalCode || "",
              companyCertifications: companyDetails?.certifications || [],
              companyContact: companyDetails?.companyContact || [
                { contant1: "9448380669" },
                { contant2: "7411677666" },
              ],
              companyMail: companyDetails?.companyMail || "svah2003@gmail.com",

              items,
              poTotals,

              transaction: "Purchase",
              transactionType: "PO",
              poRoundOff:
                Number(
                  (
                    Math.round(poTotals.poTotalNetValue) -
                    poTotals.poTotalNetValue
                  ).toFixed(2)
                ) || 0,
              purchaseRemarks: header.purchaseRemarks || "",
            },
            timeZone: "Asia/Calcutta",
          };

          // call API
          try {
            console.log("Payload for PO:", groupKey, payload);
            const res = await ItemServiceV2.addInvoice(payload);
            return {
              success: res?.status === 200,
              response: res,
              poKey: groupKey,
            };
          } catch (err) {
            console.error("addInvoice error for", groupKey, err);
            return { success: false, error: err, poKey: groupKey };
          }
        })
      );

      // analyze results, refresh list
      const settled = results;
      const created = settled.filter(
        (s) => s.status === "fulfilled" && s.value && s.value.success
      ).length;
      const totalGroups = groupEntries.length;

      toast.success(`${created}/${totalGroups} POs created successfully`);
      setParsedData([]);
      setShowDataModal(false);

      try {
        navigate(CustomerConstants.CUSTOMER_V2_PURCHASE_LIST);
        setTimeout(() => window.location.reload(), 600);
      } catch {
        window.location.reload();
      }
    } catch (err) {
      console.error("handleSaveUploadedData - error:", err);
      toast.error("Bulk upload failed: " + (err.message || "unknown error"));
    } finally {
      setDisabled(false);
    }
  };

  const InvoiceColumns = [
    {
      name: "PO No",
      selector: (row) => row.pONumber,
      width: "90px",
    },
    {
      name: "Invoice No",
      selector: (row) => row.invoiceNr,
      sortable: true,
      width: "130px",
    },
    {
      name: "Invoice Date",
      selector: (row) => row.generatedDate,
      sortable: true,
      width: "120px",
    },
    {
      name: "Company Code",
      selector: (row) => row.companyCode,
      sortable: true,
      width: "120px",
    },
    {
      name: "Customer Code",
      selector: (row) => row.customerCode,
      sortable: true,
      width: "120px",
    },
    {
      name: "Purchase Remarks",
      selector: (row) => row.purchaseRemarks,
      sortable: false,
      width: "160px",
    },

    { name: "Item No", selector: (row) => row.itemNo, width: "80px" },
    {
      name: "Material Code",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "130px",
    },
    {
      name: "Material Description",
      selector: (row) => row.materialLongText,
      sortable: true,
      width: "200px",
    },
    { name: "UOM", selector: (row) => row.uOM, sortable: true, width: "80px" },
    { name: "Qty", selector: (row) => row.qty, sortable: true, width: "80px" },
    {
      name: "Gross Value",
      selector: (row) => row.grossValue,
      sortable: true,
      width: "120px",
    },
    {
      name: "IGST %",
      selector: (row) => row.igstRate,
      sortable: true,
      width: "100px",
    },
    {
      name: "Dispatch Date",
      selector: (row) => row.dispatchDate,
      sortable: true,
      width: "120px",
    },
    {
      name: "HSN/SAC",
      selector: (row) => row.hsn_sac,
      sortable: true,
      width: "110px",
    },
    {
      name: "Errors",
      selector: (row) => (row.__errors ? row.__errors.join(", ") : ""),
      wrap: true,
      width: "200px",
    },
  ];

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [filterShow, setFilterShow] = useState(false);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const detailedPageInvoice = (purchaseNo) => {
    dispatch(purchaseNr(purchaseNo));
    navigate(Constants.CUSTOMER_V2_PURCHASE_DETAILS);
  };

  const createPO = () => {
    navigate(CustomerConstants.CUSTOMER_V2_PURCHASE_CREATION);
  };

  // Invoice Table Col
  const purchaseDataColumn = [
    {
      name: "Purchase Number",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageInvoice(row.documentNumber)}
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Transaction",
      selector: (row) => row.transaction,
      cell: (row) => (
        <>
          <span class="bg-table-status bg-table-new-status">
            {row.transaction}
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Company",
      id:"companyCodeDesc",
      selector: (row) => row.companyCode,
      cell: (row) => (
        <>
          <span className="fw-bold text-success">{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },

    {
      name: "Purchase Date",
      id: "createdAt",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">
            {formatDateTime(row.createdAt)}
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Customer",
      id:"customerName",
      selector: (row) => row.customerCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row.customerName} </p>
          <p className="m-0 p-0 pt-1">{row.customerCode} </p>
        </div>
      ),
    },
    {
      name: "Purchase Value",
      selector: (row) => row?.totals?.poTotalNetValue,
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row?.poTotals?.poTotalNetValue).toFixed(2))}
        </span>
      ),
      sortable: true,
      width: "160px",
    },
  ];

  // Invoice Item Table Col
  const lineItemColInfo = [
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.materialDescription} </p>
          <p className="m-0 p-0 ">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Load confirm Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.poOrderQuantity} </p>
          <p className="m-0 p-0 ">{row?.uOM} </p>
        </div>
      ),
      width: "150px",
    },
    // {
    //   name: "Unit Price",
    //   cell: (row) => <span>{row?.unitPrice} </span>,
    //   width: "100px",
    // },
    // {
    //   name: "Basic Price",
    //   selector: (row) => row?.basicPrice || "--",
    //   cell: (row) => <span>{row?.basicPrice} </span>,

    //   sortable: true,
    //   width: "120px",
    // },
    {
      name: "Gross Value",
      selector: (row) => row.grossValue || "--",
      cell: (row) => <span>{row.grossValue} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "Basic Amt",
      selector: (row) => row.poBasicAmount || "--",
      cell: (row) => <span>{row.poBasicAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "CGST",
      selector: (row) => row?.cgstValue || "--",
      cell: (row) => <span>{row?.cgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "SGST",
      selector: (row) => row?.sgstValue || "--",
      cell: (row) => <span>{row?.sgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "GST",
      selector: (row) => row?.gstValue || "--",
      cell: (row) => <span>{row?.gstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "IGST",
      selector: (row) => row?.igstAmount || "--",
      cell: (row) => <span>{row?.igstAmount} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "CGST%",
      selector: (row) => row?.cgst || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "SGST%",
      selector: (row) => row?.sgst || "--",
      sortable: true,
      width: "100px",
    },
  ];

  // Changed the columns added PO No and Item No

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getCustomerIPurchaseList",
      page: page,
      per_page: getNewPerPage,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getPurchaseList(obj));
    setData(purchaseData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getCustomerIPurchaseList",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getPurchaseList(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "getCustomerIPurchaseList",
      page: page,
      per_page: newPerPage,
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(getPurchaseList(obj));
    setData(purchaseData?.data);
  };

  const loadInitialPOData = async () => {
    setData(purchaseData?.data);
  };

  useEffect(() => {
    loadInitialPOData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchaseData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "getCustomerIPurchaseList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getPurchaseList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "getCustomerIPurchaseList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      rowFilter: {
        $and: [filters],
      },
    };
    dispatch(getPurchaseList(obj));
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Purchase</h2>
                <p className="subText">Lists of Purchase and details</p> 
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={purchaseDataColumn}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>

                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PL</span>
                    </Col>

                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Purchase List</span>
                      <span className="subHeaderTitle">
                        View of Purchase and Status{" "}
                      </span>
                    </Col>
                    {/* <Col xs={4} md={2} lg={2} className="me-2">
                      <button
                        className="btnTable"
                        onClick={createPO}
                      >
                        <i className="bi bi-person-plus"></i> Create PO
                      </button>
                    </Col>
                    <Col xs={4} md={2} lg={2} className="me-2">
                      <button
                        className="btnTable"
                        onClick={() => setShowUploadModal(true)}
                      >
                        Upload
                      </button>
                    </Col> */}
                    <Col xs={12} md={7} lg={7} className="headerButtonAlign">
                      <Col xs={4} md={4} lg={7} className="me-2">
                        <DownloadExcelTemplate type="PURCHASEINVOICE" />
                      </Col>
                      <Col xs={4} md={4} lg={7} className="me-2">
                        <button
                          className="btnTable"
                          onClick={() => setShowUploadModal(true)}
                        >
                          Upload
                        </button>
                      </Col>
                      <Col xs={4} md={4} lg={7} className="me-2">
                        <button className="btnTable" onClick={createPO}>
                          <i className="bi bi-person-plus"></i> Create Purchase Order
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={purchaseDataColumn}
                          data={data}
                          progressPending={purchaseData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={purchaseDataTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <UploadModal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        onUploadComplete={handleUploadComplete}
      />
      <UploadDataViewModal
        show={showDataModal}
        onHide={() => setShowDataModal(false)}
        data={parsedData}
        columns={InvoiceColumns}
        title="Uploaded Purchase Data"
        // onSave={(data) => {
        //   // Your API save logic here
        //   console.log("Save", data);
        //   setShowDataModal(false);
        // }}
        disabled={disable}
        onClick={() => handleSaveUploadedData(parsedData)}
      />

      {/* <UploadPurchaseOrder
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
      // onSuccessUpload={handleUploadSuccess}
      /> */}
    </main>
  );
};

export default PurchaseList;
